import type { Language } from '@kk/domain';

/**
 * **THE CLUB GUIDE, AS PUBLISHED ON KIDDIEKREDIT.COM/GUIDES** (Evan, 16 Oct; DECISIONS 81 and 84). The PDF in the
 * portal's own language. Shown only while `PublicConfig.guidesPage` is open.
 */
export const CLUB_GUIDE_URL: Readonly<Record<Language, string>> = {
  en: 'https://cdn.prod.website-files.com/5f9c3fbbc6757e9b918d8be9/6ad1797a8b7bf5a24da81bc8_kiddie-kredit-club-guide-en.pdf',
  es: 'https://cdn.prod.website-files.com/5f9c3fbbc6757e9b918d8be9/6ad1797b0c1ab3d100466dd5_kiddie-kredit-guia-para-clubes-es.pdf',
};
